document.addEventListener('DOMContentLoaded', () => {
    formValidation();
});

// Función para cerrar mensajes
function formValidation() {
    document.querySelectorAll('.success a').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function (event) {
            event.preventDefault();
            this.closest('.success').style.display = 'none';
        });
    });
}